export default "__VITE_ASSET__DGsfdJI1__";